import { Box, CircularProgress } from '@mui/material';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { UserContext } from 'contexts/UserContext';
import { WebFormContext, WebFormContextType } from 'contexts/WebFormContext';
import { api } from 'services/api';

import ComplexOverview from './complex-personenbelasting-aangifte-voorbereiding-2025/Overview';
import { steps as complexPersonenbelastingSteps } from './complex-personenbelasting-aangifte-voorbereiding-2025/steps';
import ComplexOverview2026 from './complex-personenbelasting-aangifte-voorbereiding-2026/Overview';
import { steps as complexPersonenbelasting2026Steps } from './complex-personenbelasting-aangifte-voorbereiding-2026/steps';
import Overview2025 from './personenbelasting-aangifte-voorbereiding-2025/Overview';
import { steps as personenbelasting2025Steps } from './personenbelasting-aangifte-voorbereiding-2025/steps';
import Overview2026 from './personenbelasting-aangifte-voorbereiding-2026/Overview';
import { steps as personenbelasting2026Steps } from './personenbelasting-aangifte-voorbereiding-2026/steps';

const PERSONENBELASTING_2025_SLUGS = [
  'personenbelasting-aangifte-voorbereiding-2025',
  'personenbelasting-aangifte-voorbereiding-2025-2',
] as const;

function getFormConfig(slug: string | undefined) {
  if (slug === 'complex-personenbelasting-aangifte-voorbereiding-2025') {
    return {
      Overview: ComplexOverview,
      steps: complexPersonenbelastingSteps,
    };
  }
  if (slug === 'complex-personenbelasting-aangifte-voorbereiding-2026') {
    return {
      Overview: ComplexOverview2026,
      steps: complexPersonenbelasting2026Steps,
    };
  }
  if (slug === 'personenbelasting-aangifte-voorbereiding-2026') {
    return {
      Overview: Overview2026,
      steps: personenbelasting2026Steps,
    };
  }
  if (
    slug &&
    (PERSONENBELASTING_2025_SLUGS as readonly string[]).includes(slug)
  ) {
    return {
      Overview: Overview2025,
      steps: personenbelasting2025Steps,
    };
  }
  return { Overview: Overview2025, steps: [] };
}

export function WebFormLayout() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState<any>(null);
  const [step, setStep] = useState<number>(0);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { Overview, steps } = getFormConfig(form?.slug);

  const contextData = useMemo<WebFormContextType>(
    () =>
      ({
        form,
        setForm,
        step,
        setStep,
        totalSteps: steps.length,
        Overview,
        steps,
      } as any),
    [form, step, Overview, steps],
  );

  useEffect(() => {
    (async () => {
      if (!id) {
        // navigate('/');
        return;
      }

      const form = await api.getForm(
        id,
        searchParams.get('clientId')
          ? Number(searchParams.get('clientId'))
          : user.id,
      );
      if (!form) {
        navigate('/');
        return;
      }

      setForm(form);
      setStep(form.isFilled ? -1 : form.data.step ?? 0);
    })();
  }, [id]);

  useEffect(() => {
    if (!form?.data) {
      return;
    }

    api.saveForm(form.id, form.data);
  }, [form?.data]);

  if (!form) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <WebFormContext.Provider value={contextData}>
      <Outlet />
    </WebFormContext.Provider>
  );
}
